import React from 'react';
import { CheckCircle2 } from 'lucide-react';
interface BonusCardProps {
  number: number;
  title: string;
  imageUrl: string;
  features: string[];
}
export function BonusCard({
  number,
  title,
  imageUrl,
  features
}: BonusCardProps) {
  const checkoutUrl = 'https://checkout.kitspremium.online/checkouts/cn/hWN81PN5tDmZUSxM6PtIJcxu/es-ar?_r=AQABi2NGslsxSM9K1DQh-oqjkrcPYJgZUp2o8gsDNeNO-jc';
  return <a href={checkoutUrl} className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col h-full cursor-pointer block" data-id="element-1">
      <div className="relative" data-id="element-2">
        <div className="block overflow-hidden group" data-id="element-3">
          <img src={imageUrl} alt={`Bonus ${number}: ${title}`} className="w-full h-64 object-cover object-center transform transition-transform duration-500 group-hover:scale-105" data-id="element-4" />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300" data-id="element-5" />
        </div>
        <div className="absolute top-4 left-4 bg-yellow-500 text-white font-bold px-4 py-1 rounded-full shadow-md border-2 border-yellow-400" data-id="element-6">
          BONO {number}
        </div>
      </div>

      <div className="p-6 flex-1 flex flex-col" data-id="element-7">
        <h3 className="text-xl font-bold text-gray-900 mb-4 leading-tight" data-id="element-8">
          {title}
        </h3>

        <ul className="space-y-3 mt-auto" data-id="element-9">
          {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-10">
              <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-11" />
              <span className="text-gray-600 text-sm leading-snug" data-id="element-12">
                {feature}
              </span>
            </li>)}
        </ul>
      </div>
    </a>;
}